import { gql } from '@apollo/client';

import { candidateShareInviteDetails, relationDetails } from './sharedApiConstants';

export const RETURN_CANDIDATESHARE_INVITES_FOR_CANDIDATE = gql`
query fetchCandidateShareInvitesForMe{
  fetchCandidateShareInvitesForMe{
    ${candidateShareInviteDetails}
  }
}
`;

export const QUERY_CANDIDATE_REFERENCER_RELATIONS_FOR_ME = gql`
  query candidateReferencerRelationsForMe {
    candidateReferencerRelationsForMe {
      ${relationDetails}
    }
  }
`;

export const CREATE_CANDIDATESHARE_INVITE = gql`
  mutation CreateCandidateShareInviteForMe($input: CandidateShareInviteForMeInput!) {
    createCandidateShareInviteForMe(input: $input) {
      ${candidateShareInviteDetails}
    }
  }
`;

export const FETCH_SHAREABLE_CRRS_FOR_ME = gql`
  query fetchShareableCRRsForMe {
    fetchShareableCRRsForMe {
      candidateReferencerRelationId
      isArchived
      isPublic
      referencerFirstName
      referencerLastName
      referenceRequests {
        referenceRequestId
      }
    }
  }
`;
